module.exports = __webpack_public_path__ + "static/media/ic_error.e7385a9b.svg";